import {hideMainLoader, showMainLoader} from "../../../actions";
import request from "../../../../utils/request";
import {requestConfig} from "../../../../config/apiResource";
import { getCmsDataDescypt } from "../LearnersCorner/actions";

export const getWhatsAppService = () => {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getWhatsAppService())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: 'GET_WHATSAPP_SERVICE' , data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with WhatsApp Service content " + error)
            });
    }
}
export const getCsrfToken = () => {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getCsrfTokenService())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: 'GET_WHATSAPP_SERVICE_TOKEN' , data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with WhatsApp Service content " + error)
            });
    }
}
export const register = (data, token) => {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.registerWhatsApp(data, token))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: 'REGISTER_WHATSAPP' , data: JSON.parse(getCmsDataDescypt(json.data)) });
                return JSON.parse(getCmsDataDescypt(json.data));
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with WhatsApp Service Register " + error)
            });
    }
}
export const registerDistributor = (data, token) => {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.registerDistributorWhatsApp(data, token))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: 'REGISTER_DISTRIBUTOR_WHATSAPP' , data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with WhatsApp Distributor Service Register " + error)
            });
    }
}

export const getWhatsappMeta = () => {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getWhatsappMeta())
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: 'GET_WHATSAPP_SERVICE_META', data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with WhatsApp Service Meta " + error)
            });
    }
}